// extracted by mini-css-extract-plugin
module.exports = {"subs":"c36dd3","subs__title":"_3cca5f","subs__content":"_83f5e4","subs__content-block":"d9b3cb","subs__content-empty":"_2d933e","subs__btn":"_5a9bc8"};